import { SelectOfferPayload } from "@/app/services/crefazService/selectOffer";
import { httpClient } from "@/app/services/http/httpClient";

export interface SelectOfferCrefazPayload extends SelectOfferPayload {
  propostaId: string;
}

export async function selectOfferCrefaz(
  linkName: string,
  payload: SelectOfferCrefazPayload,
) {
  const { data } = await httpClient.patch(
    `/self-hire/${linkName}/offer/select`,
    {
      type: "CREFAZ",
      providerData: payload,
    },
  );
  return data;
}
